/**
 * Groups order.line_items by shipments[].line_item_ids.
 *
 * The wizard form is still indexed as items.${index} in line_items order.
 * Each grouped item keeps `formIndex` so the UI can bind without remapping
 * the form when we add package headers.
 *
 * Ids are compared as strings — Shopify ids may arrive as numbers.
 */

const UNSHIPPED_ID = "unshipped";

function itemId(item) {
  return String(item?.id ?? "");
}

export function groupLineItemsByPackage(order) {
  const lineItems = order?.line_items ?? [];
  const shipments = order?.shipments ?? [];
  const assignedIds = new Set();
  const groups = [];

  shipments.forEach((shipment, shipmentIndex) => {
    const items = [];

    (shipment.line_item_ids ?? []).forEach((id) => {
      const matchIndex = lineItems.findIndex(
        (item, index) =>
          itemId(item) === String(id) && !assignedIds.has(`${itemId(item)}:${index}`)
      );

      if (matchIndex === -1) {
        return;
      }

      const lineItem = lineItems[matchIndex];
      assignedIds.add(`${itemId(lineItem)}:${matchIndex}`);
      items.push({ lineItem, formIndex: matchIndex });
    });

    if (!items.length) {
      return;
    }

    groups.push({
      id: shipment.tracking_number || `shipment-${shipmentIndex}`,
      kind: "shipment",
      trackingNumber: shipment.tracking_number ?? null,
      status: shipment.status ?? null,
      items,
    });
  });

  const unshippedItems = lineItems.flatMap((lineItem, formIndex) => {
    if (assignedIds.has(`${itemId(lineItem)}:${formIndex}`)) {
      return [];
    }
    return [{ lineItem, formIndex }];
  });

  if (unshippedItems.length) {
    groups.push({
      id: UNSHIPPED_ID,
      kind: "unshipped",
      trackingNumber: null,
      status: null,
      items: unshippedItems,
    });
  }

  return groups;
}

/** Hide package chrome when there is only one group (today's flat list). */
export function shouldShowPackageSections(groups) {
  return (groups?.length ?? 0) > 1;
}
